import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminTable from "../../../components/AdminTable";
import { API_DOMAIN } from "config"; 

export default function AdminOffers() {
  const { kind } = useParams();              // "providers" | "dealers"
  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetch(`${API_DOMAIN}/admin/users?type=${kind}`)
      .then(r => r.json())
      .then(setRows);
  }, [kind]);

  const columns = [
    { name:"ID", selector:r=>r.id, width:"80px", sortable:true },
    { name:"שם", selector:r=>r.name, sortable:true },
    { name:"טלפון", selector:r=>r.phone },
    { name:"דוא\"ל", selector:r=>r.email },
    { name:"נוצר ב‑", selector:r=>r.creation_date, sortable:true },
    { name:"סטטוס", selector:r=>r.status, width:"90px",
      cell:r=><span className={`font-assistant text-xs font-semibold ${r.status ? "text-light_green-800" : "text-red-a700_03"}`}>
                {r.status? "פעיל":"חסום"}
              </span>}
  ];

  return (
    <div className="p-4 bg-blue_gray-50 min-h-[calc(100vh-4rem)]" dir="rtl">
      <AdminTable title={kind==="providers"?"ספקים":"סוחרים"} rows={rows} columns={columns} />
    </div>
  );
}
